import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useGlobalSlice } from "app/slice";
import { MobileAccount } from "app/pages/Customer/NetworkPlanPurchase/MultiNetworkSelection/components/mobile-account";
import { VleMobileAccount } from "app/pages/Customer/NetworkPlanPurchase/SingleNetworkSelection/components/vle-mobile-account";

import { Button } from "app/components/ui/button";
import { Dialog, DialogContent, DialogClose } from "app/components/ui/dialog";

interface MobileAccountDialogProps {
  isOpen: boolean;
  onClose: () => void;
  networkType: 1 | 2; // 1 for Single Network, 2 for Multi Network
  verifyData?: any;
  verifyLoading?: boolean;
  activeLines?: number;
}

export const MobileAccountDialog: React.FC<MobileAccountDialogProps> = ({
  isOpen,
  onClose,
  networkType,
  verifyData,
  verifyLoading = false,
  activeLines = 1,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { actions } = useGlobalSlice();

  const handleClose = () => {
    sessionStorage.removeItem("userJustVerified");
    dispatch(actions.setUser({ user: null, rememberDevice: false }));
    navigate("/network-plan");
  };

  const handleGoToDashboard = () => {
    sessionStorage.removeItem("userJustVerified");
    navigate("/my-account/dashboard");
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="top-1/2 gap-4 sm:gap-5 lg:gap-6 bg-white w-[95%] sm:max-w-[33.5rem] p-4 sm:p-5 lg:p-6">
        {/* Close button */}
        <DialogClose
          className="absolute top-4 right-4 sm:top-5 sm:right-5 lg:top-6 lg:right-6 rounded-full"
          onClick={handleClose}
        >
          <img
            src="/assets/close-circle.webp"
            className="flex-shrink-0 w-5 h-5 rounded-full opacity-90 md:w-6 md:h-6 hover:opacity-100"
            alt="Close"
          />
        </DialogClose>
        {/* main section  */}
        {/* <div className=""> */}
        {networkType === 1 ? (
          <VleMobileAccount
            verifyData={verifyData}
            verifyLoading={verifyLoading}
          />
        ) : (
          <MobileAccount
            activeLines={activeLines}
            verifyData={verifyData}
            verifyLoading={verifyLoading}
          />
        )}
        {/* </div> */}
        {/* Note above Go to Dashboard button */}
        <p className="text-black text-xs sm:text-sm font-normal leading-5 text-center">
          You can add new lines or upgrade plan any time from your dashboard
        </p>
        {/* Go to Dashboard button */}
        <Button type="button" variant="outline" onClick={handleGoToDashboard}>
          Go to Dashboard
        </Button>
      </DialogContent>
    </Dialog>
  );
};
